import React from "react";
import moment, { Moment } from "moment";
import { FontSize, FontFamily } from "config/font";
import { Text } from "components/Typography/text.styled";
import {
  ArrowSign,
  MonthSelectContainer,
} from "../../../timeReport/monthlyOverview.styled";
import { TipGridHeader, TipHeadCell, ActionsHeadCell } from "../tips.styled";
import { useTranslation } from "react-i18next";

type HeaderSectionProps = {
  currentDate: Moment;
  setCurrentDate: (date: Moment) => void;
};

export const HeaderSection: React.FC<HeaderSectionProps> = (props) => {
  const { t } = useTranslation();

  const handlePreviousMonth = () => {
    props.setCurrentDate(moment(props.currentDate).subtract(1, "months"));
  };

  const handleNextMonth = () => {
    props.setCurrentDate(moment(props.currentDate).add(1, "months"));
  };

  const capitalizedMonth =
    props.currentDate.format("MMMM")[0].toUpperCase() +
    props.currentDate.format("MMMM").slice(1);

  return (
    <>
      <MonthSelectContainer>
        <ArrowSign
          onClick={handlePreviousMonth}
          title={t("CompanyTip.PreviousMonth")}
        >
          &#60;
        </ArrowSign>
        <Text
          fontSize={FontSize.H4}
          fontFamily={FontFamily.MontserratSemiBold}
          style={{ margin: 0 }}
        >
          {capitalizedMonth} {props.currentDate.year()}
        </Text>
        <ArrowSign onClick={handleNextMonth} title={t("CompanyTip.NextMonth")}>
          &#62;
        </ArrowSign>
      </MonthSelectContainer>

      <TipGridHeader>
        <TipHeadCell style={{display: "flex", justifyContent: "start"}}>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {t("CompanyTip.Date")}
          </Text>
        </TipHeadCell>
        <TipHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {t("CompanyTip.EarnedTip")}
          </Text>
        </TipHeadCell>
        <TipHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {t("CompanyTip.Remaining")}
          </Text>
        </TipHeadCell>
        <TipHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {t("CompanyTip.Status")}
          </Text>
        </TipHeadCell>
        <ActionsHeadCell>
          <Text
            fontSize={FontSize.Large}
            fontFamily={FontFamily.MontserratSemiBold}
          >
            {t("CompanyTip.Manage")}
          </Text>
        </ActionsHeadCell>
      </TipGridHeader>
    </>
  );
};
